// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: プロンプト一覧（履歴に無いサーバーの内容は取込済み）
const AdminOpsPromptListApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_prompt_list";

    const ExecAdminOpsPromptListApi = async () => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: {} });
    };

    return ExecAdminOpsPromptListApi;
};

export default AdminOpsPromptListApi;
